import React from 'react';
import {Box, Typography} from '@mui/material';
import {BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {PlanRow} from '../CreateBuilder/BuilderSourceDestination/PlanRow';
import {PlanAccordionShell} from '../CreateBuilder/BuilderSourceDestination/PlanAccordionShell';
import {PlanSelector} from '../CreateBuilder/BuilderSourceDestination/PlanSelector';
import {getSubplanSummaryParts} from '../CreateBuilder/BuilderSourceDestination/builderNaming';

interface ModifySourceSubplanProps {
  subPlan: BuilderPot_dentistChildren;
  isSelected: boolean;
  handleChange: () => void;
}

export const ModifySourceSubplan: React.FC<ModifySourceSubplanProps> = ({
  subPlan,
  isSelected,
  handleChange,
}) => (
  <PlanRow
    id={subPlan.id}
    reccId={subPlan.originalOvrId ?? null}
    curoId={subPlan.curoId}
    isSelected={isSelected}
    isSubplan
  >
    <PlanAccordionShell
      expanded={false}
      isSelected={isSelected}
      isSoleParent={false}
      flat
      compact
      validationLevel={null}
      summaryChildren={
        <>
          <PlanSelector
            mode="single"
            id={subPlan.id}
            isSelected={isSelected}
            handleChange={handleChange}
          />
          <Box display="flex" flex={1} justifyContent="space-between" alignItems="center">
            <Typography variant="body2">
              {getSubplanSummaryParts(subPlan).label}
            </Typography>
            {getSubplanSummaryParts(subPlan).currentValue && (
              <Typography variant="body2" sx={{ml: 2, whiteSpace: 'nowrap'}}>
                {getSubplanSummaryParts(subPlan).currentValue}
              </Typography>
            )}
          </Box>
        </>
      }
    />
  </PlanRow>
);
